import TeacherAPI from '@/apis/business/teacher/teacher-api.js'
import AuthTeacherAPI from '@/apis/business/account/auth-api.js'
import NotifySmartAPI from '@/apis/business/common/notify-smart-api.js'
import { HttpStatusCode } from '@/common/constant'
export default {
  namespaced: true,

  state: {
    tags: [],
    organizations: [],
    notifySmarts: []
  },

  getters: {
    /**
     *
     * @param {*} state
     * @param {Object} filter
     * - GradeID      Mã khối
     * - SubjectCode  Mã môn
     * - Limit        Số lượng
     */
    getTags: state => ({ GradeID, SubjectCode }) => {
      // nếu không có GradeID và SubjectCode thì trả về mảng rỗng
      // if (!GradeID && !SubjectCode) {
      //   return []
      // }

      // lọc

      let res = state.tags?.filter(tag => {
        return (!GradeID || GradeID === tag.GradeID) && (!SubjectCode || SubjectCode === tag.SubjectCode)
      })

      // lấy mảng tên thẻ
      res = res.map(tag => {
        return tag.TagName
      })

      // nhóm những phần tử giống nhau
      res = res.reduce((accumulator, currentValue) => {
        if (accumulator.indexOf(currentValue) < 0) accumulator.push(currentValue)
        return accumulator
      }, [])

      return res.slice(0, 15)
    }
  },

  mutations: {
    /**
     * @author PVThang
     * @description set danh sách tag
     * @param {*} state
     * @param {*} tags Danh sách tag
     */
    setTags (state, tags) {
      state.tags = tags
    },

    setOrganizations (state, organizations) {
      state.organizations = organizations
    },

    setNotifySmart (state, notifySmarts) {
      state.notifySmarts = notifySmarts
    }
  },

  actions: {
    /**
     * @author PVThang
     * @param {*} context
     * @param {*} params
     * @description Lấy danh sách Tag
     */
    async getTags (context, params) {
      params ??= {}
      const res = await TeacherAPI.getAsync('tag' +
          `?gradeID=${params.GradeID || ''}` +
          `&subjectCode=${params.SubjectCode || ''}`
      )

      if (res?.Data) {
        context.commit('setTags', res.Data)
      }
    },

    async getOrganization (context) {
      return new Promise((resolve, reject) => {
        AuthTeacherAPI.getAsync('organization').then((res) => {
          resolve(res)
          context.commit('setOrganizations', res.Data)
        }).catch(err => {
          reject(err)
        })
      })
    },

    async updateOrganization (context, param) {
      return new Promise((resolve, reject) => {
        AuthTeacherAPI.putAsync('organization', param).then((res) => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @author NVThang
     * @description gọi sang partner lấy danh sách lịch sắp diễn ra và insert notify smart
     */
    async getTeacherTrainingNotify (context, params) {
      await NotifySmartAPI.postAsync(`teacher-training?misaId=${params}`)
    },

    /**
     * @author NVThang
     * @description lấy danh sách notify
     * @param {*} context
     */
    async getNotifySmart (context) {
      const res = await NotifySmartAPI.getAsync('', { params: { Skip: 0, Limit: 1 } })
      if (res.IsSuccess && res.Data && res.Code === HttpStatusCode.OK) {
        context.commit('setNotifySmart', res.Data)
      }
    },

     /**
     * @author NVThang
     * @description set lại preview của notify
     * @param {*} context
     * @param {*} params
     */
    async setNotifyPreview (context, params) {
      await NotifySmartAPI.putAsync(`/${params.Id}`, params)
    }
  }
}
